<mux-player
  #player
  [style.--controls]="controls() ? null : 'none'"
  [attr.src]="src()"
  [attr.playback-id]="src() ? null : playbackId()"
  [attr.playback-token]="src() ? null : playbackToken()"
  [attr.stream-type]="streamType()"
  [attr.autoplay]="autoplay() ? '' : null"
  [attr.muted]="muted() ? '' : null"
  [attr.loop]="loop() ? '' : null"
  [attr.preload]="preload()"
  [attr.poster]="poster()"
  [attr.title]="videoTitle()"
  [attr.accent-color]="accentColor()"
  [attr.primary-color]="primaryColor()"
  [attr.secondary-color]="secondaryColor()"
  [attr.start-time]="startTime()"
  [attr.metadata-video-title]="metadataVideoTitle()"
  [attr.metadata-viewer-user-id]="metadataViewerUserId()"
></mux-player>
